import React, { useState, useRef, useEffect } from 'react';
import ReactJoyride from 'react-joyride';

import dist_instr from "./images/dist_instr.png";
import slider_tour from "./images/slider-tour.png";
import Button from '@mui/material/Button';
const ResultsOnboardingSteps = () => {

  const needsResetRef = useRef(false);
  const inDrawerTransitionRef = useRef(false);
  const closeHandledRef = useRef(false);
  const [currentDrawer, setCurrentDrawer] = useState(null); // Track which drawer is open: null, 'variables', or 'datetime'

  // All possible tour steps
  const allSteps = [

    {
      title: "New Variable Selection UI",
      target: ".new-control-form-center-panel",
      placement: "right",
      drawer: 'variables',
      content: <div>
        <p>Rather than listing all 90-100 variables in a long list, the MMS science department has encouraged selecting variables by their characteristics rather than by MMSVIS-chosen names.</p>
        <p>When enough characteristics are chosen (electrons, PSD, GSE, etc.),
          the variable appears in the Selected Variables list on the right with a descriptive name.</p> </div>,
      disableBeacon: true
    },
    {
      title: "Select w/o Burst for Fast-only data",
      target: ".custom_stack_plot_survey",
      drawer: 'variables',
      content: "Generally all of our plots include burst data and fast survey data together. You can use these radio buttons to indicate fast-only data.",
      disableBeacon: true
    },

    {
      title: "Burst Tracker - Required for Distribution Plots",
      target: ".custom_stack_plot-trackers-burst-tracker",
      drawer: 'variables',
      content: "If the burst tracker is not selected, the option to generate distribution plots will not be available.",
      disableBeacon: true
    },
    {
      title: "Global Coordinates - GSE, GSM",
      target: ".custom_stack_plot-coordinates-gse",
      drawer: 'variables',
      content: "All the variables will be plotted in one of these coordinate systems.",
      disableBeacon: true
    },

    {
      title: "Selected Variables",
      //target: ".new-control-form-selected-vars-container",
      target: ".new-control-form-right-panel",
      drawer: 'variables',
      placement: "left",
      content: <div> These are the variables to be plotted. The user may drag and drop the variables in the list to re-order them in the resulting plot.
        <p /><p>Hover over a name to see its CDF name in a tooltip.</p>
      </div>,
      disableBeacon: true
    },
    {
      title: "Preset Stackplot Selections",
      target: ".new-control-form-left-panel",
      placement: "right",
      drawer: 'variables',
      content: <div>Most of these items are common stackplots. They will each pre-select multiple variables from the Custom Stack Plot panel, which will also appear in Selected Variables panel. <p /> Use the "Select None" radio button to de-select all of the variables.
        <p /> The "Custom" radio button will be selected if you modify the given list.</div>,
      disableBeacon: true
    },
    {
      title: "Multi-Spacecraft FPI Plot",
      target: ".preset-preset12",
      drawer: 'variables',
      content: "This preset allows you to plot FPI data from multiple MMS spacecraft simultaneously for comparison. It is unique in that it will let you choose which of the spacecraft you want to include by offering them as checkboxes.",
      disableBeacon: true
    },
    {
      title: "Revert to Previous Variable Selection Set",
      target: ".revert-button",
      drawer: 'variables',
      content: <div>This will restore the selections from your previous plot. <p /> This is useful if you want to make a quick change to a variable and then revert back to the previous selection.</div>,
      disableBeacon: true,
    },





    {
      title: "Change the Date Range of the Plot To Match The SITL Selection",
      target: ".auto-complete",
      drawer: 'datetime',
      content: "The SITL selections for burst periods of note are listed here. Select a row to indicate the center of the time period of your plot.",
      disableBeacon: true,
    },
    {
      title: "Event Search",
      target: ".SITL",
      placement: "right",
      drawer: 'datetime',
      content: <div>
        <p>The Event Search panel lets you explore events from three sources:</p>
        <ul>
          <li><strong>SITL Comments:</strong> Search scientist-in-the-loop event descriptions</li>
          <li><strong>Scientific Papers:</strong> Find events documented in research papers</li>
          <li><strong>Featured Events:</strong> Quick access to important or notable events from Webster et al. (2018)</li>
        </ul>
        <p>Select an event to apply its time period in the plot.</p>
      </div>,
      disableBeacon: true
    },
    {
      title: "The Plot is Interactive ",
      target: ".plotly-placement",
      placement: "center",
      drawer: null,
      content: <div><p>Plots can be zoomed into by clicking and dragging vertically, horizontally, or by clicking and dragging a rectangular area.</p>
        <p>The scales can be moved by clicking on the numeric values on the left (Y axis) of a plot and dragging vertically.</p>
        <p>Clicking anywhere on a spectrogram toggles the no-data color between light and dark.</p></div>,
      disableBeacon: true,
    },
    {
      title: "Plotting Burst Distributions ",
      target: ".tour_burst",
      placement: "auto",
      drawer: null,
      content: <div>
        <div>
          <a>
            <img href='#' src={slider_tour} alt={'slider'} width="103" height="160" style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }} />
          </a>
        </div>
        <div>
          <p>Once distributions are activated, this is represented by the appearance of a translucent, blue line running vertically through all the plots.
            Grab this line and drag it left or right to a new time position.
            That time will appear in a Distribution Plot widget.  The distribution plots will be generated using this time value.
          </p>
        </div></div>,

      disableBeacon: true,
    },
    {
      title: "Plot Options Menu",
      target: ".options-icon",
      placement: "auto",
      offset: 100,
      drawer: null,
      content: <div><p>Click the Options button to access plot controls including:</p>
        <ul>
          <li>Download Plot as PNG</li>
          <li>Download Plot as SVG (for creating PDFs)</li>
          <li>Reset Axes</li>
          <li>Toggle No Data Color in Spectrograms</li>
          <li>Show/Hide Time Slider</li>
        </ul>
        <p>To create a PDF, download as SVG first. Most browsers can then view the SVG file and export/print it to PDF.</p>
      </div>,
      disableBeacon: true
    },
    {
      title: "Reset Axes",
      target: ".options-icon",
      placement: "bottom",
      spotlightPadding: 110,
      offset: 100,
      drawer: null,
      content: <div>This menu selection will reset all the axes of the stack-plot.</div>,
      disableBeacon: true
    },
    {
      title: "Plot Previous Time Period ",
      target: ".leftarrow",
      placement: "auto",
      drawer: null,
      content: "Fetch data and plot the previous time period(according to the selected duration).",
      disableBeacon: true
    },
    {
      title: "Plot Next Time Period ",
      target: ".rightarrow",
      placement: "auto",
      drawer: null,
      content: "Fetch data and plot the next time period.",
      disableBeacon: true
    },

    /**
     * DISTRIBUTIONS
     **/
    {
      title: "Get Started with Distributions ",
      target: ".plot-subheaders",
      placement: "bottom-end",
      drawer: null,
      content: <div>This will place a vertical line over the graph which you can move to the right or left
        (that is, forwards or backwards along the time axis to select a time for the distribution plot).</div>,
    },

    {
      title: "Browse or Publish ",
      target: ".brow-pub",
      placement: "auto",
      requiresDistributions: true,
      drawer: null,
      skipVisibilityCheck: true,
      content: <div>20 sets of 3 distribution plots are nominally returned when the user requests distribution plots.
        In order to save time, these plots are abbreviated.
        Selecting “Publish" instead of “Browse" will return fewer (5 sets of 3) more-complete/detailed distribution plots.</div>,
      disableBeacon: true
    },
    {
      title: "Persistent Distribution Plot Parameters ",
      target: "#dist-button",
      drawer: null,
      requiresDistributions: true,
      skipVisibilityCheck: true,
      content: "You can maintain the size, zoom level, and color range of each subsequent processing of distribution plots with these selections",
    },
    {
      title: "Slice Thickness",
      target: ".slice-thickness-label",
      drawer: null,
      requiresDistributions: true,
      skipVisibilityCheck: true,
      content: "Slice Thickness is the the maximum energy level used to determine the thickness of the slice. The range is 2.5 - 1000",
      disableBeacon: true
    },
    {
      title: "Energy Level Max",
      target: ".electron-energy-max",
      drawer: null,
      requiresDistributions: true,
      skipVisibilityCheck: true,
      content: "Electron Energy Max is the upper range of energies to include when selecting the radial bins of the plot. The range is 18 to 31",
      disableBeacon: true
    },
    {
      title: "Image Size ",
      target: ".image-size",
      requiresDistributions: true,
      drawer: null,
      skipVisibilityCheck: true,
      content: "Adjust this number (anything above 200) to change the image size. (The default is 350.)",
    },
    {
      title: "Next Distribution Zoom Level ",
      target: ".zoomText",
      placement: "auto",
      requiresDistributions: true,
      drawer: null,
      skipVisibilityCheck: true,
      content: <div>
        <p>Although the distribution plots are interactive, to change the zoom level
          of subsequent burst velocity distribution plots, change this number to anything above 230.</p>
        Default values:<br />
        ion zoom level:1500<br />
        electron zoom level 12000
      </div>,
      disableBeacon: true
    },
    {
      title: "Apply the Changes ",
      target: ".tour_apply",
      requiresDistributions: true,
      drawer: null,
      skipVisibilityCheck: true,
      content: <div>Apply the changes you have made to the controls to create a set of distributions at the selected time.
        <p /> Note that this button only applies to the distribution plots that have already been displayed below</div>
    },
    {
      title: "Color Range Slider ",
      target: ".color-slider",
      placement: "auto",
      drawer: null,
      requiresDistributions: true,
      skipVisibilityCheck: true,
      content: <div><p>There is a default color bar which covers the color range 0-255.
        (Range of phase space density (PSD) values  may vary.)
        If the user needs to focus on a certain range of values, use this double slider to focus the entire range
        of colors to a narrower range of values.</p>
        For example, if the range of PSD values are 1E-30 to 1E-24, but the user wants to focus on the values around 1E-26,
        an estimation of that color can be made. Slide the two outer boundaries of the color range
        slider by moving one or both ends of the slider toward the middle. Then hit the Apply button and a new set of
        distribution plot processing will be initiated with all of the colors focused around values 1E-26. Lower
        values will be saturated in dark blue. Higher values will be saturated in dark red.
      </div>,
      disableBeacon: true
    },
    {
      title: "Show the Next 3 Slices ",
      target: ".next-dist-right",
      placement: "auto",
      drawer: null,
      requiresDistributions: true,
      content: <div>20 sets of 3 slices are currently displayed. This button will display the next set of these 20 sets.
        The initial selection of a set of 3 will be slow to generate because although the data is on your desktop, it is  not loaded into the page.
        When the set of 3 is subsequently selected, the same set will appear very quickly.</div>,
      disableBeacon: true
    },
    {
      title: "Process the Next Set of Distribution Plots ",
      target: ".arrow-housing-dist-right",
      placement: "auto",
      drawer: null,
      requiresDistributions: true,
      content: "Fetch the next 20 sets of 3 distribution plot slices from the server.",
      disableBeacon: true
    },
    {
      title: "Cycle through all of the Distribution Plot Slices ",
      target: ".play-movie-button-housing",
      placement: "auto",
      drawer: null,
      requiresDistributions: true,
      content: "Play through all of the distribution slices at your selected pace. This will automatically advance the distribution plot slices at a rate determined by the slider. The slider can be adjusted to make the slices advance faster or slower.",
      disableBeacon: true
    },

    {
      title: "Distribution Plots ",
      target: ".dist-plot-container",
      placement: "left-start",
      drawer: null,
      requiresDistributions: true,
      content: <div><p>A set of three axial magnetic-field-aligned views are displayed.</p>
        The data is sliced from a single skymap.
        The thickness of the slice is based on a velocity-space slice thickness of 2,000 km/s
        (which corresponds to an energy-space thickness of approximately 10 eV) for dayside DES electron distributions.
      </div>,

      disableBeacon: true

    },
    /**
     * RELATED MATERIAL
     **/
    {
      title: "MMS Satellite Position and Formation ",
      target: ".button-position-xy",
      drawer: null,
      content: "Show satellite XY Position, XZ Position and Formation",
      disableBeacon: true
    },
    {
      title: "Download Displayed Data ",
      target: ".button-position-download",
      drawer: null,
      content: "Download the CDF files for the data displayed." + " The data returned will only be the displayed duration.",
      disableBeacon: true
    },
  ];

  // Detect which drawer is currently open
  useEffect(() => {
    const detectOpenDrawer = () => {
      // Check for variables drawer
      const variablesDrawer = document.querySelector('.new-control-form-center-panel');
      if (variablesDrawer && window.getComputedStyle(variablesDrawer).display !== 'none') {
        setCurrentDrawer('variables');
        return;
      }

      // Check for datetime drawer  
      const datetimeDrawer = document.querySelector('.auto-complete');
      if (datetimeDrawer && window.getComputedStyle(datetimeDrawer).display !== 'none') {
        setCurrentDrawer('datetime');
        return;
      }

      // No drawer open
      setCurrentDrawer(null);
    };

    // Detect initially
    detectOpenDrawer();

    // Set up a mutation observer to detect drawer changes
    const observer = new MutationObserver(detectOpenDrawer);
    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    return () => observer.disconnect();
  }, []);

  const checkDistInstructionsVisible = () => {
    const elem = document.getElementById('middle-dist-id');
    if (elem != null) {
      if (elem == null || window.getComputedStyle(document.getElementById('middle-dist-id')).display === 'none') {
        return false;
      }
      else {
        return true;
      }
    }
    return false;
  }
  // Filter steps based on current drawer AND whether the target element exists in DOM
  const getFilteredSteps = () => {
    // Check if distributions are active by looking for actual plot content
    const checkDistributionsActive = () => {

      const distContainer = document.querySelector('#ion-dr0');
      if (!distContainer) return false;
      // Check if it has actual plotly content (SVG)
      const hasSVG = distContainer.querySelector('svg');
      return !!hasSVG;
    };

    // Check if an element exists and is visible/accessible
    const isElementAccessible = (selector) => {
      const element = document.querySelector(selector);
      if (!element) {
        return false;
      }

      // Check if element or any parent has display: none or visibility: hidden
      let current = element;
      while (current && current !== document.body) {
        const style = window.getComputedStyle(current);
        if (style.display === 'none' || style.visibility === 'hidden') {
          return false;
        }
        current = current.parentElement;
      }

      // Check if element has actual dimensions (not collapsed via CSS)
      const rect = element.getBoundingClientRect();
      if (rect.width === 0 || rect.height === 0) {
        return false;
      }

      return true;
    };

    const distributionsActive = checkDistributionsActive();

    const filtered = allSteps.filter(step => {
      if (step.drawer !== currentDrawer) return false;
      // If step requires distributions, check if they're active
      if (step.requiresDistributions && !checkDistInstructionsVisible) {
        return false;
      }

      // Check if target element exists
      // For steps that skip visibility check (collapsed accordions), only check DOM existence
      let accessible = !!document.querySelector(step.target);
      if (step.requiresDistributions) {
        accessible = checkDistInstructionsVisible();
      }


      // Debug logging for distribution steps
      if (step.requiresDistributions || step.skipVisibilityCheck) {
          //console.log(`Distribution step filtered out - target not accessible: ${step.target} - "${step.title}"`);
      }

      return accessible;
    });
    return filtered;
  };

  const [joyride, setJoyride] = useState({
    run: false,
    stepIndex: 0,
    steps: getFilteredSteps()
  });

  // Update joyride steps when drawer changes or DOM updates
  useEffect(() => {
    const updateSteps = (force = false) => {
      const newFilteredSteps = getFilteredSteps();
      setJoyride(prev => {
        // Don't update during a running tour unless it's a drawer change (forced)
        if (prev.run && !force) {
          return prev;
        }

        // Only update if steps have actually changed to avoid unnecessary re-renders
        if (JSON.stringify(prev.steps.map(s => s.target)) !== JSON.stringify(newFilteredSteps.map(s => s.target))) {
          return {
            ...prev,
            steps: newFilteredSteps,
            stepIndex: 0,
            run: force ? false : prev.run  // Stop tour if drawer changed, otherwise maintain state
          };
        }
        return prev;
      });
    };

    // Force update when drawer changes (even if tour is running)
    updateSteps(true);

    // Also watch for DOM changes that might add/remove tour targets
    const observer = new MutationObserver(() => {
      // Debounce to avoid too many updates, don't force (respect running tour)
      setTimeout(() => updateSteps(false), 100);
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    return () => observer.disconnect();
  }, [currentDrawer]);

  // Handle Enter key to advance tour
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && joyride.run) {
        // Find and click the Next/Done button
        const nextButton = document.querySelector('button[data-action="primary"]');
        if (nextButton) {
          nextButton.click();
        }
      }
    };

    if (joyride.run) {
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [joyride.run]);

  const handleJoyrideCallback = (data) => {
    const { action, index, type, status, lifecycle } = data;

    // Reset close handled flag when tour starts
    if (action === 'start' && type === 'tour:start') {
      closeHandledRef.current = false;
    }

    // Ignore all callbacks while we're handling a close event
    if (closeHandledRef.current && action !== 'start') {
      console.log('Ignoring callback - close is being handled');
      return;
    }

    // Catch auto-restart after pause and stop it
    if (needsResetRef.current && action === 'start' && type === 'tour:status' && status === 'running') {
      console.log('Blocking auto-restart - tour needs reset');
      setJoyride({ ...joyride, run: false });
      return;
    }

    const currentStep = joyride.steps[index];


    // Scroll to distributions section if starting tour at tour_click_here step
    if (type === 'tour:start' && currentStep?.target === '.tour_click_here') {
      console.log('Tour starting at tour_click_here, scrolling...');
      setTimeout(() => {
        const target = document.querySelector('.tour_click_here');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'center' });
          console.log('Scrolled to tour_click_here on tour start');
        }
      }, 200);
    }

    // Handle step transitions
    if (type === 'step:after' && lifecycle === 'complete') {
      const nextIndex = index + (action === 'prev' ? -1 : 1);
      const nextStep = joyride.steps[nextIndex];

      if (!nextStep) {
        // Tour ending, normal progression
        setJoyride({ ...joyride, stepIndex: nextIndex });
        return;
      }

      // Close options dialog if leaving the options-icon step
      // This indeed seems to close the drop-down-menu
      if (currentStep?.target === '.options-icon' && nextStep.target !== '.options-icon') {
        console.log('Leaving options-icon step, closing options dialog');
        const dialog = document.getElementById('options-dialog');
        if (dialog) {
          const event = new CustomEvent('closeOptionsDialog');
          window.dispatchEvent(event);
        }
      }



      // Special handling: open options dialog for options-icon 
      // drop-down-menu
      if (nextStep.target === '.options-icon') {
        console.log('=== STEP TRANSITION TO options-icon ===');

        inDrawerTransitionRef.current = true;
        setJoyride({ ...joyride, run: false, stepIndex: nextIndex });

        setTimeout(() => {
          const optionsDialog = document.getElementById('options-dialog');

          if (!optionsDialog) {
            const event = new CustomEvent('openOptionsDialog');
            window.dispatchEvent(event);

            setTimeout(() => {
              inDrawerTransitionRef.current = false;
              setJoyride({ ...joyride, run: true, stepIndex: nextIndex });
            }, 400);
          } else {
            setTimeout(() => {
              inDrawerTransitionRef.current = false;
              setJoyride({ ...joyride, run: true, stepIndex: nextIndex });
            }, 100);
          }
        }, 150);

        return;
      }

      // Normal step progression
      setJoyride({ ...joyride, stepIndex: nextIndex });
    }

    if (action === 'close') {
      if (closeHandledRef.current) {
        console.log('Close already handled, ignoring');
        return;
      }
      closeHandledRef.current = true;

      const actualStep = (type === 'tour:status' && status === 'paused') ? index - 1 : index;

      needsResetRef.current = false;
      setJoyride({ ...joyride, run: false, stepIndex: actualStep });

      setTimeout(() => {
        closeHandledRef.current = false;
      }, 200);
      return;
    } else if (action === 'skip' || status === 'skipped') {
      needsResetRef.current = false;
      setJoyride({ run: false, stepIndex: 0, steps: joyride.steps });
    } else if (status === 'finished') {
      needsResetRef.current = false;
      setJoyride({ run: false, stepIndex: 0, steps: joyride.steps });
    } else if (status === 'paused' && type === 'tour:status') {
      if (!inDrawerTransitionRef.current) {
        console.log('Setting needsResetRef to true');
        needsResetRef.current = true;
      }
      setJoyride({ ...joyride, run: false });
      return;
    }
  };

  return (
    <React.Fragment>
      <Button
        id="onboarding-2"
        className='take-tour-btn'
        onClick={() => {
          console.log('TAKE TOUR clicked - Current drawer:', currentDrawer, 'Steps available:', joyride.steps.length);

          // Check if we need to reset due to paused tour
          let startIndex = joyride.stepIndex;
          if (needsResetRef.current) {
            needsResetRef.current = false;
            startIndex = 0;
          }

          // Only show tour if there are steps available for the current view
          if (joyride.steps.length === 0) {
            console.log('No tour stops available for current view');
            //alert('Please open a drawer (Variables or DateTime) or view the main Results page to see tour stops for that section.');
            return;
          }

          const currentStep = joyride.steps[startIndex];

          // Special handling: scroll to distributions for tour_click_here
          if (currentStep?.target === '.tour_click_here') {
            console.log('TAKE TOUR: Starting at tour_click_here, scrolling first');
            const target = document.querySelector('.tour_click_here');
            if (target) {
              target.scrollIntoView({ behavior: 'smooth', block: 'center' });
              setTimeout(() => {
                console.log('Scrolled, starting tour');
                setJoyride(prevState => ({ ...prevState, run: true, stepIndex: startIndex }));
              }, 800);
              return;
            }
          }



          // Start tour immediately for current view
          console.log('Starting tour for current view');
          setJoyride(prevState => ({ ...prevState, run: true, stepIndex: startIndex }));
        }}
        style={{
          color: 'white',
          marginRight: '20px'
        }}>
        TAKE TOUR</Button>
      {/* </div> */}
      <ReactJoyride
        steps={joyride.steps}
        run={joyride.run}
        stepIndex={joyride.stepIndex}
        callback={handleJoyrideCallback}
        spotlightPadding={joyride.steps[joyride.stepIndex]?.customSpotlightPadding || 50}
        continuous
        showSkipButton
        disableOverlayClose={false}
        hideBackButton={false}
        locale={{
          skip: "Exit",
          last: "Done"
        }}
        styles={{
          options: {
            arrowColor: 'white',
            backgroundColor: '#ffffff',
            overlayColor: 'rgba(0, 15, 39, 0.35)',
            primaryColor: '#163B76',
            textColor: '#000000',
            textSize: '8px',
            width: 300,
            zIndex: 1500
          },
          tooltipContainer: {
            lineHeight: 1.4,
          },
          tooltipTitle: {
            fontSize: 18,
            margin: 0,
            color: 'black',
            textAlign: 'center',
          },
          tooltipContent: {
            color: '#626A85',
            fontSize: 14,
            textAlign: 'left',
            padding: '20px 10px',
          },
          tooltipFooter: {
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'flex-end'
          },
          tooltipFooterSpacer: {
            flex: 1,
          },
          buttonClose: {
            display: 'none',
          },
          buttonNext: {
            backgroundColor: "#163B76",
            borderRadius: 4,
            fontSize: 16,
            color: 'white',
          },
          buttonSkip: {
            color: '#626A85',
            fontSize: 14,
            text: "exit"
          },
          buttonBack: {
            color: '#626A85',
            marginLeft: 'auto',
            marginRight: 15,
          }
        }}


      />


    </React.Fragment>
  );
};


export default ResultsOnboardingSteps